import React, { Component } from 'react';
import '../styles/roadmap.css';
import $ from "jquery";
import icon from '../assets/costume.png';
import icon2 from '../assets/star (2).png';

window.addEventListener("scroll", reveal);

$(window).on('scroll', function () {
    function isScrollIntoView(elem, index) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(window).height() * .5;
        if (elemBottom <= docViewBottom && elemTop >= docViewTop) {
            $(elem).addClass('active');
        }
        if (!(elemBottom <= docViewBottom)) {
            $(elem).removeClass('active');
        }
    }
    var timeline = $('.vertical-scrollable-timeline li');
    Array.from(timeline).forEach(isScrollIntoView);
});
function reveal() {
    var reveals = document.querySelectorAll(".reveal");

    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 15;

        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
        } else {
            reveals[i].classList.remove("active");
        }
    }
}
window.addEventListener("scroll", reveal);

$(window).on('scroll', function () {
    function isScrollIntoView(elem, index) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(window).height() * .5;
        if (elemBottom <= docViewBottom && elemTop >= docViewTop) {
            $(elem).addClass('active');
        }
        if (!(elemBottom <= docViewBottom)) {
            $(elem).removeClass('active');
        }
    }
    var timeline = $('.vertical-scrollable-timeline li');
    Array.from(timeline).forEach(isScrollIntoView);
});

class Roadmap extends Component {

    render() {
        return (
            <div class="boxWrap2Rm">
                <div class="roadmapBlur">

                    <div class="conT" data-aos="zoom-in" data-aos-duration="700">LOADMAP</div>
                    <p></p>
                    <div class="conT2" data-aos="zoom-in" data-aos-duration="700">Key Committee Members and Their Credentials</div>

                    <div class="timeline-container">
                        <ul class="vertical-scrollable-timeline">
                            <li>
                                <h2>2025 Q1</h2>
                                <p><img class="rmNote" src={icon2} />Launch of the official NFT website</p>
                                <p><img class="rmNote" src={icon2} />Coverage by major Chinese media</p>
                                <p><img class="rmNote" src={icon2} />Production of the first global music track</p>
                                <p><img class="rmNote" src={icon2} />Establishment of the production studio</p>
                                <p><img class="rmNote" src={icon2} />Launch of the official YouTube channel</p>
                                <p><img class="rmNote" src={icon2} />Official release of MSC</p>
                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>
                            <li>
                                <h2>2025 Q2</h2>

                                <p><img class="rmNote" src={icon2} />Release of Bunda Angels IP products</p>
                                <p><img class="rmNote" src={icon2} />Finalization of theme park and hotel site contracts</p>
                                <p><img class="rmNote" src={icon2} />Production of over 10 global music tracks and commencement of global auditions</p>
                                <p><img class="rmNote" src={icon2} />Development of the Bunda Wallet</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>
                            <li>
                                <h2>2025 Q3</h2>

                                <p><img class="rmNote" src={icon2} />Submission of district unit plan for project approval</p>
                                <p><img class="rmNote" src={icon2} />Production of over 10 global music tracks and continuation of global auditions</p>
                                <p><img class="rmNote" src={icon2} />Beta release of the Star Battle application</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>

                            <li>
                                <h2>2025 Q4</h2>

                                <p><img class="rmNote" src={icon2} />Approval of the first construction plan and groundbreaking</p>
                                <p><img class="rmNote" src={icon2} />Production of over 10 global music tracks and continuation of global auditions</p>
                                <p><img class="rmNote" src={icon2} />Collaboration with famous artists for remake tracks and release</p>
                                <p><img class="rmNote" src={icon2} />Year-end music performance reviews and awards</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>

                            <li>
                                <h2>2026 Q1</h2>

                                <p><img class="rmNote" src={icon2} />Inspection and grand opening of theme park and hotel buildings</p>
                                <p><img class="rmNote" src={icon2} />Launch of Idol Survival Auditions</p>
                                <p><img class="rmNote" src={icon2} />Production of over 10 global music tracks</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>
                            <li>
                                <h2>2026 Q2</h2>

                                <p><img class="rmNote" src={icon2} />Environmental, traffic, and disaster impact assessments</p>
                                <p><img class="rmNote" src={icon2} />Production of over 10 global music tracks</p>
                                <p><img class="rmNote" src={icon2} />Additional collaborations with famous artists for remake tracks and release</p>
                                <p><img class="rmNote" src={icon2} />Announcement event for web music variety shows</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>

                            <li>
                                <h2>2026 Q3</h2>

                                <p><img class="rmNote" src={icon2} />Approval and groundbreaking for the second construction phase</p>
                                <p><img class="rmNote" src={icon2} />Official release of the Star Battle application</p>
                                <p><img class="rmNote" src={icon2} />Beta release of the Treasure Hunt application</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>

                            <li>
                                <h2>2026 Q4</h2>

                                <p><img class="rmNote" src={icon2} />Installation of large-scale camping zones, shuttle buses, and night markets within the theme park</p>
                                <p><img class="rmNote" src={icon2} />Disclosure of partnered travel agencies</p>
                                <p><img class="rmNote" src={icon2} />Year-end music performance reviews and awards</p>
                                <p><img class="rmNote" src={icon2} />This timeline reflects a comprehensive roadmap for development, including music production, auditions, application launches, and large-scale construction projects.</p>

                                <div class="icon-holder">
                                    <img class="iconPlace" src={icon} />
                                </div>
                            </li>

                        </ul>
                    </div>

                </div>

            </div>
        )
    }
}

export default Roadmap;